/**
 * @import {SubmitAction} from 'nova';
 */

import {FormController, location} from 'nova';
import {query} from '@acng/frontend-bounty/dom/query.js';
import {guard, IS_HTML} from '@acng/frontend-rubicon';
import {make, localStore, trackOncePerMinute, USER_IMAGE_CROP, UserProfileImageApi} from './api.js';
import {UserImageUpload} from './upload.js';
import {Size} from '@acng/frontend-bounty/dom/observe.js';
import {createPromise} from '@acng/frontend-bounty/std/control.js';
import {on} from '@acng/frontend-bounty/dom/event.js';

class UserImageCrop extends FormController {
  /** @type {string | undefined} */
  image;

  /**
   * @param {URL | string} referer
   * @param {URL | string} image
   *
   * @returns {void}
   */
  setup(referer, image) {
    /* Stay safe ?
    if (USER_IMAGE_CROP in localStore) {
      throw this;
    }
    */
    const data = {
      url: `${referer}`,
      image: `${image}`,
    };

    DEBUG: this.reason.log('Set up.', data);
    // Validate data? could set this.error and stuff

    localStore[USER_IMAGE_CROP] = data;
  }

  #leave() {
    location.replace(`${localStore[USER_IMAGE_CROP]?.url ?? '/'}`);
    delete localStore[USER_IMAGE_CROP];
  }

  /**
   * Lazy load cropperjs.
   */
  async compile() {
    await import('cropperjs');
  }

  /** @param {HTMLFormElement} form */
  upgrade(form) {
    const cropperCanvas = query(form, 'cropper-canvas');
    const cropperImage = query(form, 'cropper-image');
    const cropperSelection = query(form, 'cropper-selection');

    ASSERT: {
      guard(cropperCanvas, IS_HTML);
      guard(cropperImage, IS_HTML);
      guard(cropperSelection, IS_HTML);
    }

    this.image = localStore[USER_IMAGE_CROP]?.image;

    Size(() => {
      cropperImage.$center('contain');
      cropperSelection.$center();
    })(cropperCanvas);

    on(form, 'reset', () => this.#leave());
  }

  /**
   * @type {SubmitAction}
   */
  async submit(form, data) {
    const cropperSelection = query(form, 'cropper-selection');
    ASSERT: guard(cropperSelection, IS_HTML);

    cropperSelection.hidden = true;

    const canvas = await cropperSelection.$toCanvas();
    //canvas.toDataURL('image/jpeg');
    const blob = await createPromise((resolve) =>
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            throw this;
          }

          //window.open(URL.createObjectURL(blob), '_blank');
          resolve(blob);
        },
        'image/jpeg',
        0.9,
      ),
    );

    data.append('image', blob);

    await make(UserProfileImageApi)
      .post(data, form)
      .catch((e) => this.reason.error('Upload failed.', e));

    await make(UserImageUpload)
      .compile()
      .catch((e) => this.reason.warn('Upload service update failed.', e));

    trackOncePerMinute();
    this.#leave();
  }
}

export {UserImageCrop};
